module.exports = __webpack_public_path__ + "img/up-allow.8e15efa2.svg";